// extracted by mini-css-extract-plugin
export default {"root":"Anchor_root__wbkJ0","body":"Anchor_body__jYfKT","cta":"Anchor_cta__982PU","label":"Anchor_label__SBVxh"};